import React from "react";
import "./Skills.css";
import { Grid, Typography, Container } from "@mui/material";
import SingleSkill from "../../../components/Skills/SingleSkill";
import skillList from "./utils/data";

export default function Skills() {
  
  return (
    <Container>
      <Grid
        container
       
        style={{
          // backgroundColor: "blue",
          justifyContent: "center",
          alignItems: { xs: "center" },
          marginTop: "70px",
        }}
        // direction="column"
      >
        <Grid item style={{}}>
          <Typography
            variant="h5"
            sx={{
              color: "#00adb5",
              fontWeight: 500,
              fontFamily: "Getboreg Trial Only",
            }}
          >
            S K I L L S
          </Typography>
        </Grid>
        <Grid
          item
          sx={{ marginLeft: "22px", marginTop: { xs: '25px' ,md:'0px'} }}
          data-aos="fade-up"
          data-duration="5000"
        >
          <Typography
            sx={{
              color: "white",
              textAlign: { xs: "left", md: "center" },
              fontFamily: "Titillium Web",
              fontWeight: "400",
              letterSpacing: "1px",
              marginTop: { md: "60px", xs: "20px" },
              fontSize: "15px",
            }}
          >
            At the beginning of my coding journey, I wholeheartedly embraced the
            use of cutting-edge technologies. Recognizing their potential to
            transform projects, I eagerly incorporated the latest tools and
            frameworks into my work. This allowed me to streamline processes,
            increase efficiency, and deliver superior results. By constantly
            staying updated with the latest advancements, I fostered an
            environment of continuous learning and growth.
          </Typography>
        </Grid>
        <Grid
          container
          sx={{
            // backgroundColor: "yellow",
            justifyContent: "center",
            margin: { xs: "30px", md: "50px" },
            // marginTop: { xs: "70px" },
            alignItems: "center",
          }}
        >
          {skillList.map((val, key) => {
            return (
              <Grid
                item
                xs={6}
                md={2}
                style={{
                  // backgroundColor: "red",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                padding="4px"
                direction="row"
              >
                <SingleSkill val={val} key={val.id} />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Container>
  );
}
